const LumaTextField = {
  defaultProps: {
    placeholderEmail: ''
  }
};
export default LumaTextField;